import React from "react";
import "./coverPage.css";
import MorphLogo from "../../images/morphLogoWithText.svg";

const CoverPage = ({
  agents,
  client,
  company,
  profileImage,
  address,
  user,
  inspectedDate,
}) => {
  const companyImageUrl = company?.profile_image?.presigned_url;
  const profileImageUrl = profileImage?.presigned_url;
  // for dev testings
  // const profileImageUrl = undefined;

  const inspectorName = `${user?.first_name || ""} ${
    user?.last_name || ""
  }`.trim();
  const clientName = client?.name || "";
  const agentsName =
    agents
      ?.map((agent) => agent?.name)
      .filter(Boolean)
      .join(", ") || "";

  const companyPhone = company?.phone || user?.phone;
  const companyEmail = company?.email || user?.email;

  return (
    <div className="cover-page">
      {/* Header */}
      <div className="cover-header">
        <div className="company-info">
          {companyImageUrl && (
            <img
              src={companyImageUrl}
              alt="Company Logo"
              className="company-logo"
            />
          )}
          <h1 className="company-name">{company?.name}</h1>
        </div>
        <div className="contact-info">
          <p className="phone">{companyPhone}</p>
          <p className="email">{companyEmail}</p>
        </div>
      </div>

      {/* Main Image */}
      {profileImageUrl && (
        <div className="cover-image-container">
          <img
            src={profileImageUrl}
            alt="Property"
            className="property-image"
          />
        </div>
      )}

      {/* Report Info */}
      <div className={`report-info ${profileImageUrl ? "" : "no-image"}`}>
        <h2 className="title">Inspection Report</h2>
        <h3 className="subitlte property-address">
          <div className="subtitle-text">{address?.formatted_address}</div>
        </h3>
      </div>

      {/* Inspection Details */}
      <div
        className={`inspection-details ${profileImageUrl ? "" : "no-image"}`}
      >
        <div className="detail-row">
          {inspectorName && (
            <div className="detail-item">
              <span className="label">Inspected By</span>
              <span className="value">{inspectorName}</span>
            </div>
          )}
          {clientName && (
            <div className="detail-item">
              <span className="label">Client</span>
              <span className="value">{clientName}</span>
            </div>
          )}
          {inspectedDate && (
            <div className="detail-item">
              <span className="label">Inspected On</span>
              <span className="value">{inspectedDate}</span>
            </div>
          )}
          {agentsName && (
            <div className="detail-item">
              <span className="label">Agent</span>
              <span className="value">{agentsName}</span>
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="cover-footer">
        <span>
          <strong>Power by</strong>
        </span>
        <img src={MorphLogo} alt="Powered by Morph" className="morph-logo" />
      </div>
    </div>
  );
};

export default CoverPage;
